import {RouteConfig} from 'vue-router'
import {MenuItem} from '@/store/types'

/**
 * Provee las rutas del módulo de galerías
 */
export function routes (): RouteConfig[] {
    return [
        {
            name: 'galleryList',
            path: '/galerias',
            component: () => import('@/modules/cms/modules/gallery/components/GalleryList.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Lista de galerías',
                module: 'gallery',
                vuex: {
                    loadModules: ['cms'],
                },
            },
        },
        {
            path: '/galerias/:id',
            name: 'galleryDetail',
            component: () => import('@/modules/cms/modules/gallery/components/GalleryDetail.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Ver/Editar galería',
                module: 'gallery.detail',
                vuex: {
                    loadModules: ['cms', 'media'],
                },
            },
        },
    ]
}

/**
 * Provee los elementos del menu de la aplicación
 */
export function menu (): MenuItem[] {
    return [
        {
            title: 'Galerías',
            icon: 'mdi-folder-multiple-image',
            routeName: 'galleryList',
            module: 'gallery',
            requireAuthorization: true,
            permission: '@/gallery/admin',
        },
    ]
}
